import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAdmin } from './AdminContext';
import { adminFetch, ADMIN_ENDPOINTS } from '../config';
import './Admin.css';

export default function AdminLayout() {
  const { user, logout } = useAdmin();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await adminFetch(ADMIN_ENDPOINTS.logout, { method: 'POST' });
    logout();
    navigate('/admin/login', { replace: true });
  };

  return (
    <div className="admin-app">
      <nav className="admin-nav">
        <div>
          <NavLink to="/admin" end className={({ isActive }) => (isActive ? 'active' : '')}>Dashboard</NavLink>
          <NavLink to="/admin/about" className={({ isActive }) => (isActive ? 'active' : '')}>About</NavLink>
          <NavLink to="/admin/services" className={({ isActive }) => (isActive ? 'active' : '')}>Services</NavLink>
          <NavLink to="/admin/skills" className={({ isActive }) => (isActive ? 'active' : '')}>Skills</NavLink>
          <NavLink to="/admin/projects" className={({ isActive }) => (isActive ? 'active' : '')}>Projects</NavLink>
          <NavLink to="/admin/education" className={({ isActive }) => (isActive ? 'active' : '')}>Education</NavLink>
<NavLink to="/admin/messages" className={({ isActive }) => (isActive ? 'active' : '')}>Messages</NavLink>
          <NavLink to="/admin/chats" className={({ isActive }) => (isActive ? 'active' : '')}>Chats</NavLink>
              <NavLink to="/admin/settings" className={({ isActive }) => (isActive ? 'active' : '')}>Settings</NavLink>
          <NavLink to="/admin/password" className={({ isActive }) => (isActive ? 'active' : '')}>Password</NavLink>
        </div>
        <div>
          <span style={{ color: '#888', marginRight: '0.5rem' }}>{user?.username || ''}</span>
          <button type="button" className="btn btn-ghost btn-sm" onClick={handleLogout}>Logout</button>
        </div>
      </nav>
      <main className="admin-content">
        <Outlet />
      </main>
    </div>
  );
}
